import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { Formik, Form } from "formik";
import Swal from "sweetalert2";
import { Box, CircularProgress } from "@mui/material";
import {
  fetchGetAllUsuarios,
  fetchGetAllInmobiliarias,
  initializeMensaje,
  updateUsuario,
} from "../../action";
import FormUsuarioFields from "./FormUsuarioFields";
import util from "../../utils/utilsFunctions";
import "../../css/styles.css";

const validate = (formValues) => {
  const errors = {};

  if (!formValues.Nombres) {
    errors.Nombres = "Por favor ingrese sus nombres";
  }

  if (!formValues.Apellidos) {
    errors.Apellidos = "Por favor ingrese sus apellidos";
  }

  if (formValues.Rut) {
    const rutError = util.checkRut(formValues.Rut);
    if (rutError) {
      errors.Rut = rutError;
    }
  } else {
    errors.Rut = "Por favor ingrese rut";
  }

  if (!formValues.Telefono) {
    errors.Telefono = "Por favor ingrese su teléfono";
  } else if (isNaN(formValues.Telefono)) {
    errors.Telefono = "Por favor solo agregue números";
  }

  if (!formValues.Direccion) {
    errors.Direccion = "Por favor ingrese su dirección";
  }

  if (!formValues.Email) {
    errors.Email = "Por favor ingrese su email";
  }

  if (formValues.TipoCuenta === "" || formValues.TipoCuenta === undefined) {
    errors.TipoCuenta = "Por favor ingrese su tipo de cuenta";
  }

  return errors;
};

const EditarUsuario = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();

  const [usuario, setUsuario] = useState(null);

  const itemsUsuarios = useSelector((state) => state.app.itemsUsuarios || []);
  const itemInmobiliarias = useSelector(
    (state) => state.app.itemInmobiliarias || []
  );
  const requestUpdateUsuario = useSelector(
    (state) => state.app.requestUpdateUsuario
  );
  const errorMessage = useSelector((state) => state.app.errorMessage);

  let userLogueado = null;
  try {
    userLogueado = JSON.parse(localStorage.getItem("user"));
  } catch (e) {
    userLogueado = null;
  }

  useEffect(() => {
    dispatch(initializeMensaje());
    dispatch(fetchGetAllInmobiliarias());
    if (itemsUsuarios.length === 0) {
      dispatch(fetchGetAllUsuarios());
    }
  }, [dispatch]);

  useEffect(() => {
    if (id && itemsUsuarios.length > 0) {
      const foundUser = itemsUsuarios.find((u) => u.id === id || u.iduser === id);
      setUsuario(foundUser || null);
    }
  }, [id, itemsUsuarios]);

  useEffect(() => {
    if (requestUpdateUsuario === "LOADING") {
      Swal.showLoading();
    } else if (requestUpdateUsuario === "SUCCESS") {
      Swal.fire({
        icon: "success",
        title: "Usuario actualizado",
        text: "Se han actualizado los datos del usuario exitosamente",
      }).then(() => {
        history.push(
          userLogueado && userLogueado.tipoCuenta === 6
            ? "/agentes"
            : "/usuarios"
        );
      });
    } else if (requestUpdateUsuario === "ERROR") {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: errorMessage || "Error al actualizar el usuario",
      });
    }
  }, [requestUpdateUsuario, errorMessage, history]);

  const handleSubmit = (values) => {
    const data = {
      fechaNacimiento: values.FechaNacimiento,
      tipoCuenta: values.TipoCuenta,
      apellidos: values.Apellidos,
      direccion: values.Direccion,
      nombres: values.Nombres,
      oficio: values.Oficio,
      inmobiliariaId: values.InmobiliariaId,
      proyectosInmobiliariosId: values.ProyectosInmobiliariosId,
      rut: values.Rut,
      telefono: values.Telefono,
      idString: id,
      email: values.Email,
      datosBancarios: {
        banco: values.Banco,
        tipoCuenta: values.TipoCuentaBancaria,
        numeroCuenta: values.NumeroCuenta,
        medioPago: values.MedioPago,
      },
    };
    dispatch(updateUsuario(data));
  };

  const isAgenteView = userLogueado && userLogueado.tipoCuenta === 6;

  if (!usuario) {
    return (
      <div className="contenido">
        <div className="header">
          <h2>{isAgenteView ? "Actualizar Agente" : "Actualizar Usuario"}</h2>
        </div>
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <CircularProgress color="success" />
        </Box>
      </div>
    );
  }

  return (
    <div className="contenido">
      <div className="header">
        <h2>{isAgenteView ? "Actualizar Agente" : "Actualizar Usuario"}</h2>
      </div>

      <Formik
        initialValues={{
          Nombres: usuario.nombres || "",
          Apellidos: usuario.apellidos || "",
          Rut: usuario.rut ? util.formatRut(usuario.rut) : "",
          FechaNacimiento: usuario.fechaNacimiento || "",
          Telefono: usuario.telefono || "",
          Direccion: usuario.direccion || "",
          Email: usuario.email || "",
          Oficio: usuario.oficio || "",
          Password: usuario.password || "",
          ProyectosInmobiliariosId: usuario.proyectosInmobiliariosId || [],
          InmobiliariaId: usuario.inmobiliariaId || "",
          TipoCuenta: usuario.tipoCuenta !== undefined ? usuario.tipoCuenta : "",
          Banco: usuario.datosBancarios ? usuario.datosBancarios.banco : "",
          TipoCuentaBancaria: usuario.datosBancarios
            ? usuario.datosBancarios.tipoCuenta
            : "",
          NumeroCuenta: usuario.datosBancarios
            ? usuario.datosBancarios.numeroCuenta
            : "",
          MedioPago: usuario.datosBancarios
            ? usuario.datosBancarios.medioPago
            : "",
        }}
        validate={validate}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ values, errors, touched, handleChange, handleBlur, setFieldValue, isSubmitting }) => (
          <Form>
            <FormUsuarioFields
              values={values}
              errors={errors}
              touched={touched}
              handleChange={handleChange}
              handleBlur={handleBlur}
              setFieldValue={setFieldValue}
              itemInmobiliarias={itemInmobiliarias}
              usuario={usuario}
              isEdit={true}
            />

            <Box sx={{ mt: 2, mb: 4, display: "flex", gap: 2 }}>
              <button className="boton" type="submit" disabled={isSubmitting}>
                Actualizar Usuario
              </button>
              <button
                type="button"
                className="boton"
                style={{ backgroundColor: "#6c757d" }}
                onClick={() => history.push("/usuarios")}
              >
                Cancelar
              </button>
            </Box>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default EditarUsuario;
